import 'react-native-url-polyfill/auto';

import AppManifest from '../common/AppManifest';
import development from './environment.development';
import production from './environment.production';
import pat from './environment.pat';
import staging from './environment.staging';
import developmentRemote from './environment.development-remote';

export interface Environment {
  apiBaseUrl: string;
  socketUrl: string;
  webUrl: string;
  appWebUrl: string;
  accessTokenKey: string;
  bearerPrefix: string;
  expires?: number;
  secure?: boolean;
  domain?: string;
  referralUrl: string;
  fitbitWebClientId: string;
  fitbitAppClientId: string;
  oAuthRedirectWebUri: string;
  oAuthRedirectAppUri: string;
  ouraAppClientId: string;
  appcuesAppId?: string;
  appcuesAccountId?: string;
  googleFitScopes: Array<string>;
  recaptchaSiteKey: string;
  googleTagManagerId: string;
}

export default (AppManifest.env === 'staging'
  ? staging
  : AppManifest.env === 'pat'
    ? pat
    : AppManifest.env === 'production'
      ? production
      : AppManifest.env === 'development-remote'
        ? developmentRemote
        : development) as Environment;
